import type { TrackerComponentProps } from 'OpalChat/Tracker';
import React from 'react';

/**
 * Host-side lazy loader for the federated Tracker surface (`OpalChat/Tracker`),
 * mirroring `LazyAIChatComponent`. The remote chunk download starts at
 * module-eval time so it proceeds in parallel with other startup work;
 * `React.lazy` then reuses the in-flight promise.
 *
 * Phase 0: the loader exists and is unit-tested but is not yet rendered by the
 * app (no behaviour change). Phase 1 mounts it inside the host drawer chrome in
 * place of the native board.
 */
export type { TrackerComponentProps };

// Kick off the remote chunk download at module-eval time (see
// LazyAIChatComponent for the rationale) so the OpalChat/Tracker fetch runs in
// parallel with other startup work; React.lazy reuses the in-flight promise.
const OpalChatTrackerPromise: Promise<{
  default: React.ComponentType<TrackerComponentProps>;
}> = import('OpalChat/Tracker')
  .then(m => ({ default: m.TrackerComponent }))
  .catch((error: unknown) => {
    console.error('Failed to load OpalChat Tracker:', error);
    return { default: () => <div>Tracker failed to load</div> };
  });

export const LazyTracker = React.lazy(() => OpalChatTrackerPromise);
